import request from '@host-panel/request';
import { TFieldsText } from '../../single-sign-on/types';

export function editSSOAccount(type: string, data: TFieldsText) {
  return request(`/host-panel/sso-account/${type}`, {
    method: 'PUT',
    data
  });
}
